"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var momentDate_service_1 = require("./momentDate.service");
exports.MomentDateService = momentDate_service_1.MomentDateService;
//# sourceMappingURL=index.js.map